import type { SeoMeta } from '$lib/seo';

export const load = (): { seo: SeoMeta } => ({
	seo: {
		title: 'Ekavi Care — an AI back-office colleague for independent practices',
		description:
			'Ekavi Care is an AI back-office colleague for independent practices. Tell it what to do — in plain English — and it does it inside the EHR you already use (athena, eClinicalWorks, Tebra). On that foundation, four more: prior auth and eligibility end-to-end, claims and denial management, charge capture and coding (powered by your scribe — Abridge, Suki, Ambience, DAX), and scheduling + the AI receptionist (Hippocratic, Hyro, Klara). Across your clearinghouse and PA networks too (Availity, Stedi, Change Healthcare, Cohere). Recruiting five founding design-partner practices.',
		path: '/',
		pageType: 'WebPage'
	}
});
